<template>
  <div class="no-network">
    <H5Header v-if="isNativeWebUIType"></H5Header>
    <img :src="getImgIcon" alt="" />
    <div class="title">{{ $t("FoodC_c_Unable_to_cPrS") }}</div>
    <div class="desc">{{ $t("FoodC_c_Please_try_cHSE") }}</div>
    <div class="btn" @click="again">
      <div>{{ $t("FoodC_c_Try_again_lIZQ") }}</div>
    </div>
  </div>
</template>

<script>
import H5Header from '@/page/couponCenter/components/header/index.vue'
import noNetwork from "@/assets/images/abnormal/noNetwork.png";
import noNetwork99 from "@/assets/images/abnormal/noNetwork_99.png";
export default {
  components: {
    H5Header,
  },
  props:{
    isShowHeader:{
      default:true
    }
  },
  computed: {
    isNativeWebUIType() {
      return +this.params.nativeWebUIType === 1
    },
    // 获取对应的国家
    getCountry() {
      return this.$store.state.country;
    },
    getImgIcon() {
      if (this.getCountry === "BR") {
        return noNetwork99;
      } else {
        return noNetwork;
      }
    },
  },
  methods:{
    again() {
      this.$emit('update-again')
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/var.scss";
.no-network {
  position: absolute;
  width: 100%;
  background: #f3f3f3;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .header{
      height: 176px;
  }
  img {
    width: 300px;
    height: 300px;
    margin-top: 270px;
    margin-bottom: 4px;
  }
  .title {
    font-family: "Aspira Demi";
    font-size: 32px;
    color: #000000;
    text-align: center;
    line-height: 45px;
    font-weight: 700;
    margin: 0 75px;
    margin-bottom: 13px;
  }
  .desc {
    margin: 0 75px;
    font-family: "Aspira Regular";
    font-size: 24px;
    color: #000000;
    text-align: center;
    font-weight: 400;
    margin-bottom: 32px;
  }
  .btn {
    div {
      min-width: 172px;
      height: 60px;
      border-radius: 18px;
      font-family: "Aspira Demi";
      font-size: 24px;
      @include new-coupon-package-btn();
      text-align: center;
      font-weight: 700;
      background: none;
      @include new-coupon-package-btn-border();
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
